import { initialState } from "./state";

export const events = (state = initialState, action) => {
  switch (action.type) {
    case "SET_EVENTS_LIST": {
      return Object.assign({}, state, {
        eventsList: action.data
      });
    }
    case "SET_EVENT_DETAIL_LIST": {
      return Object.assign({}, state, {
        eventDetails: action.data
      });
    }
    case "SET_ACTIVE_EVENTS": {
      return Object.assign({}, state, {
        activeEvents: action.data
      });
    }
    default:
      return state;
  }
};
